var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"icon left"}),_c('div',{staticClass:"index fs32 co_023 font_w"},[_vm._v(_vm._s(Number(_vm.index) + 1))]),_c('div',{staticClass:"index fs20 co_023"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"icon right"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }